import moment from "moment"
import { localizedF, serverScheduleDateFormat } from "js/includes/common/utils"

export const repeatsOptionsMap = {
  EMPTY: {
    value: "",
    text: localizedF("components.selectField.singleSelectMessage"),
  },
  DAILY: {
    value: "DAILY",
    text: localizedF("general.daily"),
    hasRecurrence: true,
    maxRecurrence: 365,
    recurrenceText: localizedF("configuration.scheduledTasks.days"),
  },
  HOURLY: {
    value: "HOURLY",
    text: localizedF("general.hourly"),
    hasRecurrence: true,
    maxRecurrence: 12,
    recurrenceText: localizedF("general.hourOrHours"),
  },
  WEEKLY: {
    value: "WEEKLY",
    text: localizedF("general.weekly"),
    hasRecurrence: true,
    maxRecurrence: 52,
    recurrenceText: localizedF("configuration.scheduledTasks.weeks"),
  },
  MONTHLY: {
    value: "MONTHLY",
    text: localizedF("general.monthly"),
    hasRecurrence: true,
    maxRecurrence: 12,
    recurrenceText: localizedF("configuration.scheduledTasks.months"),
  },
  ON_SYSTEM_STARTUP: {
    value: "ON_SYSTEM_STARTUP",
    text: localizedF("general.onSystemStartup"),
  },
  ON_USER_LOGIN: {
    value: "ON_USER_LOGIN",
    text: localizedF("general.onUserLogin"),
  },
  NEVER: { value: "NEVER", text: localizedF("general.never") },
}

export const defaultRepeatsOptions = [repeatsOptionsMap.DAILY, repeatsOptionsMap.WEEKLY, repeatsOptionsMap.MONTHLY]

export const defaultEndOptions = [
  { value: "NEVER", text: localizedF("general.never") },
  { value: "AFTER", text: localizedF("general.after") },
  { value: "ON", text: localizedF("general.on") },
]

export const getDefaultScheduleWithDateFormat = (dateFormat = serverScheduleDateFormat) => ({
  schema: "2.0",
  dayOfMonth: 1,
  daysOfWeek: ["MON"],
  repeats: "DAILY",
  repeatsEveryCount: 1,
  runAtHour: 9,
  runAtMinute: 0,
  startDate: moment().format(dateFormat),
  end: {
    type: "NEVER",
    occurenceCount: 1,
    endDate: moment()
      .add(1, "month")
      .format(dateFormat),
  },
})

export const defaultSchedule = getDefaultScheduleWithDateFormat(serverScheduleDateFormat)
